import React from 'react'
import { useState } from 'react'
import {  useLocation } from "react-router-dom";
import {BrowserRouter as Router,Route ,Switch} from "react-router-dom"
import Login from "./route_components/Login"
import Home from "./route_components/Home"
import Home_en from "./route_components/Home_en"

import App_tid_pdf from "./route_components/App_tid_pdf"

import FrmNewRegister_th from "./route_components/FrmNewRegister_th"
import FrmNewRegister_en from "./route_components/FrmNewRegister_en"

import FrmProfile_th from "./route_components//FrmProfile_th"
import FrmProfile_en from "./route_components//FrmProfile_en"

import FrmApplication_th from "./route_components/FrmApplication_th"
import FrmApplication_en from "./route_components/FrmApplication_en"
import FrmHisScore_th from "./route_components/FrmHisScore_th"
import FrmHisScore_en from "./route_components/FrmHisScore_en"


import Navbar3 from './route_components/Navbar3'

import Notfound from './route_components/Notfound'
import Logout from './route_components/Logout'
import Posts from './route_components/Posts'
import Posts2 from './route_components/Posts2'

import {AuthContextProvider} from './route_components/AuthContext'
import PrivateRoute from './route_components/PrivateRoute'

import Frmforgotten from "./route_components/Frmforgotten"


import './route_components/mycss.css'

const App = () => { 
  return (
    <AuthContextProvider>
      <Router>
        <Layout />
      </Router>
    </AuthContextProvider>
  );
};


const Layout = () => {
  const location = useLocation(); // Get the current route
  const hideNavbar = location.pathname === "/posts2"; // Hide navbar on /posts2
  const [statuslogin,setstatuslogin] = useState('login');
    
  const handlelogin = (para1) => {

  setstatuslogin((a) => (para1));
  //console.log('statuslogin get from login.js:',statuslogin);
}

  return (
    <>
      {!hideNavbar && <Navbar3 statuslogin={statuslogin}/> } {/* Show Navbar3 only if NOT on /posts2 */}

      <Switch>
      <Route path="/" exact>
            <Home />
          </Route>
                  

          <Route path="/home">
            <Home />
          </Route>

          <Route path="/home_en">
            <Home_en />
          </Route>

          
          {/* <Route path="/App_tid_pdf">
            <App_tid_pdf />
          </Route>                       */}
         
          <Route path="/FrmNewRegister_th">
            <FrmNewRegister_th />
          </Route>
        
          <Route path="/FrmNewRegister_en">
            <FrmNewRegister_en />
          </Route>

          <PrivateRoute path="/FrmProfile_th">
            <FrmProfile_th />
          </PrivateRoute> 

          <PrivateRoute path="/FrmProfile_en">
            <FrmProfile_en />
          </PrivateRoute> 

          <PrivateRoute path="/FrmApplication_th">
            <FrmApplication_th />
          </PrivateRoute> 

          <PrivateRoute path="/FrmApplication_en">
            <FrmApplication_en />
          </PrivateRoute> 

          <PrivateRoute path="/FrmHisScore_th">
            <FrmHisScore_th />
          </PrivateRoute> 

          <PrivateRoute path="/FrmHisScore_en">
            <FrmHisScore_en />
          </PrivateRoute> 
         

          <Route path="/login">
            <Login handlelogin={handlelogin} />
          </Route>  

          <Route path="/FrmNewRegister_en">
            <FrmNewRegister_en />
          </Route>

          <Route path="/Frmforgotten">
            <Frmforgotten />
          </Route> 

          
          <PrivateRoute path="/logout">
            <Logout handlelogin={handlelogin} />
          </PrivateRoute>          
   
          <Route path="/posts2/">
            <Posts2 />
          </Route> 

          <Route path="/posts/:id">
            <Posts />
          </Route> 

          <Route>
            <Notfound />
          </Route>    
      </Switch>
    </>
  );
};


const App2 = () => {
  const [statuslogin,setstatuslogin] = useState('login');
    
  const handlelogin = (para1) => {

  setstatuslogin((a) => (para1));
  //console.log('statuslogin get from login.js:',statuslogin);
}
  
  
  return (
    <div>
     
     <AuthContextProvider>
      <Router> 

        { <Navbar3 statuslogin={statuslogin}/> }
        {/* {statuslogin !== 'login' && <Navbar3 statuslogin={statuslogin}/>} */}
        
        <Switch>          
         
          <Route path="/" exact>
            <Home />
          </Route>
                  

          <Route path="/home">
            <Home />
          </Route>

          <Route path="/home_en">
            <Home_en />
          </Route>

          
          {/* <Route path="/App_tid_pdf">
            <App_tid_pdf />
          </Route>                       */}
         
          <Route path="/FrmNewRegister_th">
            <FrmNewRegister_th />
          </Route>
        
          <Route path="/FrmNewRegister_en">
            <FrmNewRegister_en />
          </Route>

          <PrivateRoute path="/FrmProfile_th">
            <FrmProfile_th />
          </PrivateRoute> 

          <PrivateRoute path="/FrmProfile_en">
            <FrmProfile_en />
          </PrivateRoute> 

          <PrivateRoute path="/FrmApplication_th">
            <FrmApplication_th />
          </PrivateRoute> 

          <PrivateRoute path="/FrmApplication_en">
            <FrmApplication_en />
          </PrivateRoute> 

          <PrivateRoute path="/FrmHisScore_th">
            <FrmHisScore_th />
          </PrivateRoute> 

          <PrivateRoute path="/FrmHisScore_en">
            <FrmHisScore_en />
          </PrivateRoute> 
         

          <Route path="/login">
            <Login handlelogin={handlelogin} />
          </Route>  

          
          <PrivateRoute path="/logout">
            <Logout handlelogin={handlelogin} />
          </PrivateRoute>          
   
          <Route path="/posts2">
            <Posts2 />
          </Route> 

          <Route path="/posts/:id">
            <Posts />
          </Route> 

          <Route>
            <Notfound />
          </Route>      
         
      </Switch> 
               
    </Router>
    </AuthContextProvider>

    
    </div>
    
  )
}


export default App